const pageSlider = document.querySelector('.page-slider__wrapper');

if (pageSlider) {
    const sliderThumbs = pageSlider.querySelectorAll('.swiper-slide--thumbs');
    const sliderImages = pageSlider.querySelectorAll('.swiper-slide--image');
    const sliderCount = sliderThumbs.length === sliderImages.length ? sliderThumbs.length : 0;
    const imageWrapper = pageSlider.querySelector('.swiper-wrapper--images');
    const imageWrapperWidth = imageWrapper.offsetWidth ?? 0;

    if (sliderCount > 0 && imageWrapperWidth > 0) {
        pageSlider.addEventListener('focusin', () => {
            const activeElement = document.activeElement;
            const focusedThumb = activeElement.closest('.swiper-slide--thumbs');
            if (!focusedThumb) return;

            const focusedSlide = updateThumbs(focusedThumb);;
            updateImages(focusedSlide);
            updateImageWrapperTransform(focusedSlide);
        });
    }

    function updateThumbs(focusedThumb) {
        let focusedSlide = 1;
        sliderThumbs.forEach((thumb, index) => {
            if (thumb !== focusedThumb) {
                thumb.classList.remove('swiper-slide-thumb-active');
            } else {
                thumb.classList.add('swiper-slide-thumb-active');
                focusedSlide = index + 1;
            }
        });
        return focusedSlide;
    }

    function updateImages(focusedSlide) {
        sliderImages.forEach((image) => {
            image.classList.remove('swiper-slide-active', 'swiper-slide-prev', 'swiper-slide-next');
        });

        if (focusedSlide - 2 >= 0) {
            sliderImages[focusedSlide - 2].classList.add('swiper-slide-prev');
        }

        if (focusedSlide < sliderCount) {
            sliderImages[focusedSlide].classList.add('swiper-slide-next');
        }

        if (focusedSlide - 1 >= 0) {
            sliderImages[focusedSlide - 1].classList.add('swiper-slide-active');
        }
    }

    function updateImageWrapperTransform(focusedSlide) {
        imageWrapper.style.transform = `translate3d(-${imageWrapperWidth * (focusedSlide - 1)}px, 0px, 0px)`;
    }
}
